class Navigation {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'navigation-breakpoint': 1111,
        };
    }

    init() {
        this.setMegadropdownColumnNumber();
        this.closeOtherNavigationItems();
        this.closeDropdownOnFocusOut();
        this.openCurrent();
    }

    /**
     * handle grid rows per main menu dropdown
     */
    setMegadropdownColumnNumber() {
        const subMenus = $(this.elem).find('[data-children-length]');
        subMenus.each((index, item) => {
            const subMenuLength = $(item).data('children-length');
            const subMenuRows = Math.ceil((subMenuLength) / 3) + 1;

            item.style.gridTemplateRows = `repeat(${subMenuRows}, auto)`;

            Navigation.placeItemsIntoGridCellsForIE(item, subMenuRows);
        });
    }

    /**
     * add style tag only in IE and explicitly place each element
     * into its respective grid cell
     * @param item
     * @param subMenuRows
     */
    static placeItemsIntoGridCellsForIE(item, subMenuRows) {
        const isIE = window.navigator.msPointerEnabled;
        if (isIE) {
            const subMenuColumns = 3;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('type', 'text/css');

            $(item).css('-ms-grid-rows', `(auto)[${subMenuRows}]`);

            // get index of current submenu
            const navigationSubIndex = $('.o-navigation__item--main').index($(item).closest('.o-navigation__item--main')) + 1; // add 1 as nth-child doesn't work with 0

            // place every item into its grid cell
            let styleContent = `.o-navigation__item:nth-child(1) {-ms-grid-row: 1; -ms-grid-column: 1 / 4;}`;

            for (let col = 1; col <= subMenuColumns; col++) {
                for (let row = 1; row <= subMenuRows; row++) {
                    let cellStyle = '';
                    const cellNum = row + subMenuRows * (col - 1);

                    if (cellNum > 1) {
                        if (col === 1) {
                            cellStyle = `.o-navigation__item--main:nth-child(${navigationSubIndex}) .o-navigation__item:nth-child(${cellNum}) {-ms-grid-row: ${row}; -ms-grid-column: ${col};}`;
                        } else {
                            cellStyle = `.o-navigation__item--main:nth-child(${navigationSubIndex}) .o-navigation__item:nth-child(${cellNum}) {-ms-grid-row: ${row + 1}; -ms-grid-column: ${col};}`;
                        }
                    }
                    styleContent += cellStyle;
                }
            }

            styleElement.textContent = styleContent;
            document.head.appendChild(styleElement);
        }
    }

    closeOtherNavigationItems() {
        const navigationCheckboxes = $(this.elem).find('.o-navigation__toggle-sub');

        if (navigationCheckboxes.length) {
            navigationCheckboxes.on('click', (event) => {
                $(event.currentTarget).closest('.o-navigation__item')
                    .siblings().find('input')
                    .prop('checked', false);
            });
        }
    }

    closeDropdownOnFocusOut() {
        const focusableNavigationItems = $(this.elem).find(
            `.o-navigation__item > a, 
            .o-navigation__item > input`
        );

        if (focusableNavigationItems.length) {
            focusableNavigationItems.on('focusin', (event) => {
                setTimeout(function(){
                    $(event.currentTarget).closest('.o-navigation__item')
                        .siblings().find('input')
                        .prop('checked', false);
                }, 500);
            });
        }

        const firstNavigationItemCheckbox = $(this.elem).find('.o-navigation__item--main:first-child > input');

        if (firstNavigationItemCheckbox.length) {
            let isShiftPressed = false;
            firstNavigationItemCheckbox.on('keydown', (event) => {
                if (event.which === 16) {
                    isShiftPressed = true;
                }
                if (isShiftPressed && event.which === 9) {
                    firstNavigationItemCheckbox.prop('checked', false);
                }
             });
            firstNavigationItemCheckbox.on('keyup', (event) => {
                if (event.which === 16) {
                    isShiftPressed = false;
                }
            });
        }
    }

    openCurrent() {
        $(this.elem).find('.o-navigation__item--main.o-navigation__item--current > .o-navigation__toggle-sub').on('change', (e) => {
            if (window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
                if ($(e.currentTarget).is(':checked')) {
                    $('.o-navigation__item--current > .o-navigation__toggle-sub').prop('checked', true);
                }
            }
        });

        $('#main-menu-toggle').on('change', (e) => {
            if (!window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
                if ($(e.currentTarget).is(':checked')) {
                    $('.o-navigation__item--current > .o-navigation__toggle-sub').prop('checked', true);
                }
            }
        });
    }
}

export default Navigation;

